// ResizeObserver runs during layout. Defer canvas writes until the next frame
// so a scene transition cannot cause another resize in the same delivery loop.
export const observeElementSize = (element, onResize) => {
  let frame = null;
  let stopped = false;
  let previousSize = null;

  const resize = () => {
    frame = null;
    if (stopped) return;

    const size = {
      width: element.clientWidth,
      height: element.clientHeight,
      pixelRatio: window.devicePixelRatio || 1,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    };
    // Hidden scenes are resized when they become visible again.
    if (!size.width || !size.height) return;
    if (
      previousSize &&
      Object.keys(size).every((key) => size[key] === previousSize[key])
    )
      return;

    previousSize = size;
    onResize(size);
  };
  const scheduleResize = () => {
    if (stopped || frame !== null) return;
    frame = requestAnimationFrame(resize);
  };
  const observer =
    typeof ResizeObserver === 'function'
      ? new ResizeObserver(scheduleResize)
      : null;

  observer?.observe(element);
  window.addEventListener('resize', scheduleResize);
  // Initial sizing is safe outside the observer's notification callback.
  resize();

  return () => {
    stopped = true;
    observer?.disconnect();
    window.removeEventListener('resize', scheduleResize);
    if (frame !== null) cancelAnimationFrame(frame);
  };
};
